import { useApiMutation, useLocalizedApiQuery } from "../services/react-query";

export const useGetAllAnnouncements = (params) => {
  return useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["announcements", params],
      enabled: !!params.eventId,
    },
    fetchOptions: {
      url: "/announcements",
      method: "GET",
      params,
    },
  });
};

export const useGetAnnouncement = (announcementId) => {
  return useLocalizedApiQuery({
    queryOptions: { queryKey: ["announcements", announcementId] },
    fetchOptions: {
      url: `/announcements/${announcementId}`,
      method: "GET",
    },
  });
};

export const useCreateAnnouncement = () => {
  return useApiMutation({
    invalidateQueryKeys: [["announcements"]],
    fetchOptions: {
      url: "/announcements",
      method: "POST",
    },
    successMessage: {
      title: "Announcement was created successfully",
    },
  });
};

export const useUpdateAnnouncement = (announcementId) => {
  return useApiMutation({
    fetchOptions: {
      url: `/announcements/${announcementId}`,
      method: "PATCH",
    },
    successMessage: {
      title: "Announcement was updated successfully",
    },
    invalidateQueryKeys: [["announcements"]],
  });
};

export const useDeleteAnnouncement = () => {
  return useApiMutation({
    fetchOptions: {
      url: "/announcements",
      method: "DELETE",
    },
    invalidateQueryKeys: [["announcements"]],
    successMessage: {
      title: "Announcement was deleted successfully",
    },
  });
};

export const useNotifyAnnouncement = () => {
  return useApiMutation({
    invalidateQueryKeys: [["announcements"]],
    fetchOptions: {
      url: "/announcements/notify",
      method: "POST",
    },
    successMessage: {
      title: "Notification was sent successfully",
    },
  });
};

export const useCreateSpecialInvitation = () => {
  return useApiMutation({
    invalidateQueryKeys: [["announcements"]],
    fetchOptions: {
      url: "/announcements/special-invitation",
      method: "POST",
    },
    successMessage: {
      title: "Special invitation was created successfully",
    },
  });
};

export const useUpdateSpecialInvitation = (announcementId) => {
  return useApiMutation({
    invalidateQueryKeys: [["announcements"]],
    fetchOptions: {
      url: `/announcements/${announcementId}/special-invitation`,
      method: "PATCH",
    },
    successMessage: {
      title: "Special invitation was updated successfully",
    },
  });
};
